import './pdf.less';

import React from 'react';
import classNames from 'classnames';

import GridTileCaption from 'zoomforth_codesbane_viewer/viewer/sections/grid/grid_tile_caption.jsx';
import GridTileInnerTypeImage from 'zoomforth_codesbane_viewer/viewer/sections/grid/grid_tile_inner_type_image.jsx';

import { 
  getPdfIconUrl
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

export default ({ 
  asset,
  className, 
  contentItem,
  onNoEmbedPdfSectionClick
})=> {

  // @NOTE this component is meant to emulate a PDF tile so the HTML structure
  // may be strange for a section but makes sense in order to use the same
  // theme styles.

  return (
    <div
      onClick={() => { onNoEmbedPdfSectionClick(contentItem.uuid); }}
      className={classNames('pdf-section-no-embed-wrapper', className, {
        [`content-uuid-${contentItem.uuid}`]: contentItem && contentItem.uuid
      })}
    >
      <div pdf_icon="true" action_type="overlay" className="tile-wrapper type-pdf">
        <div className="tile">

          <GridTileInnerTypeImage
            zfImage={contentItem.tile_inner_zf_image}
            altText={contentItem.alt_text}
            needsCrop={false}
            imageSrc={getPdfIconUrl()}
          />

          <GridTileCaption
            captionHtml={
              asset && asset.display_filename ?
                asset.display_filename
              : contentItem ?
                contentItem.renderedTileCaption
              :
                'PDF Document'
            }
          />

        </div>
      </div>
    </div>
  );
};
